import {TraceApiEndpointBuilder} from '../traceApi';
import apiConfig from '@src/Configs/apiConfig';

export interface ConsentRequest {
  firebase_uid: string;
  email: string;
  accept_tnc: boolean;
  trace_marketing: boolean;
  partner_marketing: boolean;
}

export interface ConsentRecord extends ConsentRequest {
  id?: string;
  userId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ConsentResponse {
  success: boolean;
  consent: ConsentRecord;
}

const getConsentAuthorizationHeader = () => {
  const token = apiConfig.traceConsentAuthorization.trim();
  if (!token) {
    return undefined;
  }
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
};

const buildConsentHeaders = () => {
  const headers: Record<string, string | undefined> = {};
  
  const authHeader = getConsentAuthorizationHeader();
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  
  const apiKey = apiConfig.traceConsentApiKey?.trim();
  if (apiKey) {
    headers.apikey = apiKey;
  }
  
  return headers;
};

export const createConsentEndpoint = (builder: TraceApiEndpointBuilder) => ({
  saveConsent: builder.mutation<ConsentResponse, ConsentRequest>({
    query: body => ({
      url: apiConfig.traceConsentApiUrl,
      method: 'POST',
      body,
      contentType: 'application/json',
      noAuth: true,
      skipAuthGuard: true,
      noSession: true,
      headers: buildConsentHeaders(),
    }),
  }),
});
